(function() {
  "use strict";

  // Web-verified mileage facts sourced from manufacturer pages.
  var MODEL_FACTS = {
    "defender2": {
      warranty: "80,000 mi / 128,700 km",
      tier: "Premium",
      bestFor: "Long tread life and daily commuting",
      scoreIce: 67,
      scoreSnow: 45,
      scoreWet: 57,
      scoreDry: 79,
      scoreTread: 85,
      noise: "low"
    },
    "xicesnow": {
      warranty: "40,000 mi / 64,400 km",
      tier: "Premium",
      bestFor: "Severe winter traction",
      scoreIce: 79,
      scoreSnow: 82,
      scoreWet: 58,
      scoreDry: 59,
      scoreTread: 90,
      noise: "low"
    },
    "pilotsportas4": {
      warranty: "45,000 mi / 72,400 km",
      tier: "Premium",
      bestFor: "Sport handling year-round",
      scoreIce: 62,
      scoreSnow: 68,
      scoreWet: 91,
      scoreDry: 91,
      scoreTread: 74,
      noise: "medium"
    },
    "ltxat2": {
      warranty: "60,000 mi / 96,600 km",
      tier: "Premium",
      bestFor: "SUV and light-truck all-terrain use",
      scoreIce: 77,
      scoreSnow: 83,
      scoreWet: 88,
      scoreDry: 90,
      scoreTread: 90,
      noise: "medium"
    },
    "blizzakws90": {
      warranty: "No mileage warranty",
      tier: "Premium",
      bestFor: "Ice and snow braking",
      scoreIce: 98,
      scoreSnow: 100,
      scoreWet: 80,
      scoreDry: 70,
      scoreTread: 73,
      noise: "medium"
    },
    "weatherpeak": {
      warranty: "70,000 mi / 112,700 km",
      tier: "Premium",
      bestFor: "All-weather daily driving",
      scoreSnow: 86,
      scoreWet: 71,
      scoreDry: 80,
      scoreTread: 43,
      noise: "low"
    },
    "dueleratrevo3": {
      warranty: "60,000 mi (P-metric) / 50,000 mi (LT)",
      tier: "Premium",
      bestFor: "All-terrain trucks and SUVs",
      scoreIce: 70,
      scoreSnow: 80,
      scoreWet: 80,
      scoreDry: 80,
      scoreTread: 80,
      noise: "medium"
    },
    "weathergrip": {
      warranty: "65,000 mi / 104,600 km",
      tier: "Mid-range",
      bestFor: "All-weather value and comfort",
      scoreWet: 77,
      scoreDry: 83,
      scoreTread: 25,
      noise: "high"
    },
    "destinationle3": {
      warranty: "70,000 mi / 112,700 km",
      tier: "Mid-range",
      bestFor: "SUV highway comfort"
    },
    "destinationat2": {
      warranty: "55,000 mi / 88,500 km",
      tier: "Mid-range",
      bestFor: "Budget all-terrain use"
    },
    "trailterrainta": {
      warranty: "60,000 mi / 96,600 km",
      tier: "Premium",
      bestFor: "Light off-road and daily road use"
    },
    "allterraintako2": {
      warranty: "50,000 mi / 80,500 km",
      tier: "Premium",
      bestFor: "Serious all-terrain durability"
    },
    "allterraintako3": {
      warranty: "50,000 mi / 80,500 km",
      tier: "Premium",
      bestFor: "Next-gen all-terrain durability"
    },
    "advantagecontrol": {
      warranty: "75,000 mi (H) / 65,000 mi (V/W)",
      tier: "Mid-range",
      bestFor: "Value all-season comfort"
    },
    "potenzasport": {
      warranty: "No published mileage warranty",
      tier: "Premium",
      bestFor: "Max dry and wet performance",
      scoreWet: 87,
      scoreDry: 88,
      noise: "high"
    },
    "firehawkasv2": {
      warranty: "50,000 mi / 80,500 km",
      tier: "Mid-range",
      bestFor: "Performance all-season value"
    },
    "solusta31": {
      warranty: "60,000 mi / 96,600 km",
      tier: "Mid-range",
      bestFor: "Daily all-season comfort"
    },
    "ecstapa51": {
      warranty: "45,000 mi / 72,400 km",
      tier: "Mid-range",
      bestFor: "Sporty all-season handling"
    },
    "crugenhp71": {
      warranty: "65,000 mi / 104,600 km",
      tier: "Mid-range",
      bestFor: "SUV highway comfort"
    },
    "roadventureat52": {
      warranty: "55,000 mi (P-metric) / 50,000 mi (LT)",
      tier: "Mid-range",
      bestFor: "All-terrain trucks and SUVs"
    },
    "scorpionasplus3": {
      warranty: "70,000 mi / 112,700 km",
      tier: "Premium",
      bestFor: "SUV all-season touring"
    },
    "pzeroallseasonplus": {
      warranty: "50,000 mi / 80,500 km",
      tier: "Premium",
      bestFor: "Ultra-high-performance all-season"
    },
    "cinturatoweatheractive": {
      warranty: "60,000 mi / 96,600 km",
      tier: "Premium",
      bestFor: "All-weather touring confidence"
    },
    "scorpionallterrainplus": {
      warranty: "50,000 mi / 80,500 km",
      tier: "Premium",
      bestFor: "All-terrain traction with road comfort"
    },
    "extremecontactdws06plus": {
      warranty: "50,000 mi / 80,500 km",
      tier: "Premium",
      bestFor: "Performance all-season handling",
      scoreIce: 62,
      scoreSnow: 76,
      scoreWet: 90,
      scoreDry: 87,
      scoreTread: 68,
      noise: "medium"
    },
    "vikingcontact7": {
      warranty: "No published mileage warranty",
      tier: "Premium",
      bestFor: "Studless winter grip and braking"
    },
    "truecontacttour": {
      warranty: "80,000 mi (T/H) / 70,000 mi (V)",
      tier: "Premium",
      bestFor: "Long-life all-season touring"
    },
    "terraincontactat": {
      warranty: "60,000 mi / 96,600 km",
      tier: "Premium",
      bestFor: "Balanced on/off-road capability"
    },
    "assuranceweatherready": {
      warranty: "60,000 mi / 95,000 km",
      tier: "Premium",
      bestFor: "All-weather confidence",
      scoreWet: 80,
      scoreDry: 77,
      scoreTread: 80,
      noise: "medium"
    },
    "eaglesportallseason": {
      warranty: "50,000 mi / 80,000 km",
      tier: "Premium",
      bestFor: "Responsive all-season sport driving"
    },
    "wranglerduratracrt": {
      warranty: "50,000 mi / 80,500 km",
      tier: "Premium",
      bestFor: "Rugged-terrain trail and highway mix"
    },
    "avidascendgt": {
      warranty: "65,000 mi / 110,000 km",
      tier: "Mid-range",
      bestFor: "Quiet long-mileage touring"
    },
    "geolandaratg015": {
      warranty: "60,000 mi (P/E) / 50,000 mi (LT)",
      tier: "Mid-range",
      bestFor: "All-terrain with winter capability"
    },
    "iceguardig53": {
      warranty: "No mileage warranty (time/tread limited)",
      tier: "Mid-range",
      bestFor: "Studless winter city driving"
    },
    "observegsi6": {
      warranty: "No mileage warranty (prorated workmanship)",
      tier: "Mid-range",
      bestFor: "Studless winter traction"
    },
    "celsiusii": {
      warranty: "60,000 mi / 96,600 km",
      tier: "Mid-range",
      bestFor: "All-weather year-round driving"
    },
    "opencountryatiii": {
      warranty: "65,000 mi (P/Euro) / 50,000 mi (LT)",
      tier: "Mid-range",
      bestFor: "All-terrain durability"
    },
    "altimaxrt45": {
      warranty: "75,000 mi (T/H) / 65,000 mi (V)",
      tier: "Mid-range",
      bestFor: "Long-life all-season touring"
    },
    "grabberatx": {
      warranty: "60,000 mi (P) / 50,000 mi (LT/flotation)",
      tier: "Mid-range",
      bestFor: "All-terrain trucks and SUVs"
    },
    "altimaxarctic12": {
      warranty: "No mileage warranty (winter tire)",
      tier: "Mid-range",
      bestFor: "Studdable winter traction"
    }
  };

  var BRAND_TIER_FACTS = {
    "michelin": "Premium",
    "bridgestone": "Premium",
    "continental": "Premium",
    "goodyear": "Premium",
    "pirelli": "Premium",
    "firestone": "Mid-range",
    "bfgoodrich": "Mid-range",
    "kumho": "Mid-range",
    "toyo": "Mid-range",
    "yokohama": "Mid-range",
    "general": "Mid-range"
  };

  // Benchmarks used only when model-specific published scores are unavailable.
  var TYPE_SCORE_BENCHMARKS = {
    "winter": { scoreIce: 85, scoreSnow: 90, scoreWet: 74, scoreDry: 70, scoreTread: 68, noise: "medium" },
    "all-weather": { scoreIce: 68, scoreSnow: 78, scoreWet: 79, scoreDry: 81, scoreTread: 72, noise: "medium" },
    "all-season": { scoreIce: 55, scoreSnow: 66, scoreWet: 83, scoreDry: 84, scoreTread: 76, noise: "medium" },
    "performance-all-season": { scoreIce: 52, scoreSnow: 63, scoreWet: 88, scoreDry: 89, scoreTread: 70, noise: "medium" },
    "summer-performance": { scoreIce: 40, scoreSnow: 45, scoreWet: 86, scoreDry: 90, scoreTread: 64, noise: "high" },
    "all-terrain": { scoreIce: 62, scoreSnow: 72, scoreWet: 78, scoreDry: 81, scoreTread: 74, noise: "high" },
    "suv-truck": { scoreIce: 52, scoreSnow: 63, scoreWet: 80, scoreDry: 82, scoreTread: 77, noise: "medium" }
  };

  var tyreDatasetPromise = null;
  var tyreLookupByBrandModel = null;

  function normalizeBrandKey(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function parsePercent(value) {
    var n = Number(value);
    if (!isFinite(n) || n <= 0) return "";
    if (n > 100) return "100";
    return String(Math.round(n));
  }

  function parseRating(value) {
    var n = Number(value);
    if (!isFinite(n) || n <= 0) return "";
    return n.toFixed(1);
  }

  function inferTypeFromRow(row) {
    var text = String(row.description || row.tyre_type || "").toLowerCase();
    if (text.indexOf("winter") > -1) return "Winter";
    if (text.indexOf("all season") > -1 || text.indexOf("all-season") > -1) return "All-season";
    if (text.indexOf("summer") > -1) return "Summer";
    if (text.indexOf("suv") > -1 || text.indexOf("4x4") > -1 || text.indexOf("truck") > -1) return "SUV/Truck";
    return "";
  }

  function inferTierFromRating(rating) {
    var n = Number(rating);
    if (!isFinite(n) || n <= 0) return "";
    if (n >= 8) return "Premium";
    if (n >= 6) return "Mid-range";
    return "Budget";
  }

  function readBestFor(description) {
    var text = String(description || "").trim();
    if (!text) return "";
    var firstSentence = text.split(".")[0].trim();
    if (!firstSentence) return "";
    return firstSentence;
  }

  function getTyreDataUrl(section) {
    if (!section) return "";
    return String(section.dataset.tyreDataUrl || "").trim();
  }

  function loadTyreDataset(section) {
    if (tyreDatasetPromise) return tyreDatasetPromise;
    var url = getTyreDataUrl(section);
    if (!url) {
      tyreLookupByBrandModel = {};
      tyreDatasetPromise = Promise.resolve(tyreLookupByBrandModel);
      return tyreDatasetPromise;
    }
    tyreDatasetPromise = fetch(url)
      .then(function(response) { return response.ok ? response.json() : []; })
      .catch(function() { return []; })
      .then(function(rows) {
        var map = {};
        if (!Array.isArray(rows)) rows = [];
        rows.forEach(function(row) {
          var brandKey = normalizeBrandKey(row.brand);
          var modelKey = normalizeModelKey(row.tyre_name);
          if (!brandKey || !modelKey) return;
          var key = brandKey + "|" + modelKey;
          var existing = map[key];
          var existingReviews = Number(existing && existing.user_reviews_count || 0);
          var nextReviews = Number(row.user_reviews_count || 0);
          if (!existing || nextReviews >= existingReviews) {
            map[key] = row;
          }
        });
        tyreLookupByBrandModel = map;
        return map;
      });
    return tyreDatasetPromise;
  }

  function getTyreRowForCard(card) {
    if (!card || !tyreLookupByBrandModel) return null;
    var brandKey = normalizeBrandKey(card.dataset.modelBrand || "");
    var modelKey = normalizeModelKey(card.dataset.modelName || "");
    if (!brandKey || !modelKey) return null;
    return tyreLookupByBrandModel[brandKey + "|" + modelKey] || null;
  }

  function applyDatasetRowToCard(card, row) {
    if (!card || !row) return;

    if (!String(card.dataset.modelType || "").trim()) {
      var inferredType = inferTypeFromRow(row);
      if (inferredType) card.dataset.modelType = inferredType;
    }
    if (!String(card.dataset.modelTier || "").trim()) {
      var inferredTier = inferTierFromRating(row.rating_out_of_10);
      if (inferredTier) card.dataset.modelTier = inferredTier;
    }
    if (!String(card.dataset.modelBestFor || "").trim()) {
      var bestFor = readBestFor(row.description);
      if (bestFor) card.dataset.modelBestFor = bestFor;
    }
    if (!String(card.dataset.modelScoreWet || "").trim()) {
      card.dataset.modelScoreWet = parsePercent(row.wet_grip_percent);
    }
    if (!String(card.dataset.modelScoreDry || "").trim()) {
      card.dataset.modelScoreDry = parsePercent(row.dry_grip_percent);
    }
    if (!String(card.dataset.modelScoreSnow || "").trim()) {
      card.dataset.modelScoreSnow = parsePercent(row.snow_grip_percent);
    }
    if (!String(card.dataset.modelScoreIce || "").trim()) {
      card.dataset.modelScoreIce = parsePercent(row.ice_grip_percent);
    }
    if (!String(card.dataset.modelScoreTread || "").trim()) {
      card.dataset.modelScoreTread = parsePercent(row.wear_percent);
    }

    var rating = parseRating(row.rating_out_of_10);
    var reviews = Number(row.user_reviews_count || 0);
    if (rating) card.dataset.modelRating = rating;
    if (reviews > 0) card.dataset.modelReviews = String(reviews);
  }

  function normalizeModelKey(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/michelin|bridgestone|firestone|bfgoodrich|pirelli|continental|goodyear|yokohama/g, "")
      .replace(/[^a-z0-9]/g, "");
  }

  function getModelFacts(modelName) {
    var key = normalizeModelKey(modelName);
    return MODEL_FACTS[key] || null;
  }

  function getTypeBenchmark(typeValue) {
    var type = String(typeValue || "").toLowerCase();
    if (!type) return null;
    if (type.indexOf("performance all-season") > -1 || type.indexOf("performance all season") > -1) return TYPE_SCORE_BENCHMARKS["performance-all-season"];
    if (type.indexOf("summer performance") > -1) return TYPE_SCORE_BENCHMARKS["summer-performance"];
    if (type.indexOf("all-weather") > -1 || type.indexOf("all weather") > -1) return TYPE_SCORE_BENCHMARKS["all-weather"];
    if (type.indexOf("all-season") > -1 || type.indexOf("all season") > -1) return TYPE_SCORE_BENCHMARKS["all-season"];
    if (type.indexOf("all-terrain") > -1 || type.indexOf("all terrain") > -1) return TYPE_SCORE_BENCHMARKS["all-terrain"];
    if (type.indexOf("winter") > -1) return TYPE_SCORE_BENCHMARKS["winter"];
    if (type.indexOf("suv/truck") > -1 || type.indexOf("suv") > -1 || type.indexOf("truck") > -1) return TYPE_SCORE_BENCHMARKS["suv-truck"];
    return null;
  }

  function applyModelFactsToCard(card) {
    if (!card) return;
    var facts = getModelFacts(card.dataset.modelName || "");

    if (facts && !String(card.dataset.modelWarranty || "").trim() && facts.warranty) {
      card.dataset.modelWarranty = facts.warranty;
    }
    if (!String(card.dataset.modelTier || "").trim()) {
      if (facts && facts.tier) card.dataset.modelTier = facts.tier;
      else {
        var brandTier = BRAND_TIER_FACTS[String(card.dataset.modelBrand || "").toLowerCase()];
        if (brandTier) card.dataset.modelTier = brandTier;
      }
    }
    if (facts && !String(card.dataset.modelBestFor || "").trim() && facts.bestFor) {
      card.dataset.modelBestFor = facts.bestFor;
    }

    var body = card.querySelector(".tire-brand-explorer__card-body");
    if (!body) return;

    var metrics = body.querySelector("[data-tire-card-metrics]");
    if (!metrics) {
      metrics = document.createElement("p");
      metrics.className = "tire-brand-explorer__card-metrics";
      metrics.setAttribute("data-tire-card-metrics", "true");
      body.appendChild(metrics);
    }

    var bits = [];
    var rating = String(card.dataset.modelRating || "").trim();
    var reviews = Number(card.dataset.modelReviews || 0);
    if (rating) {
      bits.push("Tire score " + rating + "/10" + (reviews > 0 ? (" (" + reviews + " reviews)") : ""));
    } else {
      bits.push("Tire score N/A");
    }
    if (card.dataset.modelWarranty) bits.push(card.dataset.modelWarranty);
    if (card.dataset.modelTier) bits.push(card.dataset.modelTier);
    metrics.textContent = bits.join(" • ");
    metrics.hidden = bits.length === 0;
  }

  function hydrateCardsWithFacts(section) {
    section.querySelectorAll("[data-tire-card]").forEach(function(card) {
      applyModelFactsToCard(card);
    });
  }

  function hydrateCardsWithDataset(section) {
    return loadTyreDataset(section).then(function() {
      section.querySelectorAll("[data-tire-card]").forEach(function(card) {
        var row = getTyreRowForCard(card);
        if (!row) return;
        applyDatasetRowToCard(card, row);
        applyModelFactsToCard(card);
      });
    });
  }

  function lazyHydrateCardsWithDataset(section) {
    if (!section || section.dataset.tireDatasetHydrated === "true") {
      return;
    }
    section.dataset.tireDatasetHydrated = "true";
    hydrateCardsWithDataset(section).then(function() {
      syncArrows(section);
      renderDots(section);
      syncDots(section);
    });
  }

  function attachDatasetLazyLoad(section) {
    if (!section || section.dataset.tireDatasetLazyBound === "true") {
      return;
    }
    section.dataset.tireDatasetLazyBound = "true";

    function handleIntent() {
      lazyHydrateCardsWithDataset(section);
    }

    var events = ["click", "touchstart", "mouseenter", "focusin"];
    events.forEach(function(eventName) {
      section.addEventListener(eventName, handleIntent, { once: true, passive: true });
    });
  }

  function syncArrows(section) {
    var track = section.querySelector("[data-tire-track]");
    var prev = section.querySelector("[data-tire-prev]");
    var next = section.querySelector("[data-tire-next]");
    if (!track || !prev || !next) return;

    var hasOverflow = track.scrollWidth > (track.clientWidth + 1);
    prev.hidden = !hasOverflow;
    next.hidden = !hasOverflow;
    if (!hasOverflow) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    prev.disabled = track.scrollLeft <= 1;
    next.disabled = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 1);
  }

  function getCarouselPageCount(track) {
    if (!track) return 0;
    var pageWidth = Math.max(1, track.clientWidth);
    var pages = Math.ceil(track.scrollWidth / pageWidth);
    return Math.max(1, pages);
  }

  function renderDots(section) {
    var track = section.querySelector("[data-tire-track]");
    var dotsWrap = section.querySelector("[data-tire-dots]");
    if (!track || !dotsWrap) return;

    var pageCount = getCarouselPageCount(track);
    dotsWrap.innerHTML = "";

    if (pageCount <= 1) {
      dotsWrap.hidden = true;
      return;
    }

    dotsWrap.hidden = false;
    for (var i = 0; i < pageCount; i++) {
      var dot = document.createElement("span");
      dot.className = "tire-brand-explorer__dot";
      if (i === 0) dot.classList.add("is-active");
      dotsWrap.appendChild(dot);
    }
  }

  function syncDots(section) {
    var track = section.querySelector("[data-tire-track]");
    var dotsWrap = section.querySelector("[data-tire-dots]");
    if (!track || !dotsWrap || dotsWrap.hidden) return;

    var dots = dotsWrap.querySelectorAll(".tire-brand-explorer__dot");
    if (!dots.length) return;

    var pageWidth = Math.max(1, track.clientWidth);
    var pageIndex = Math.round(track.scrollLeft / pageWidth);
    if (pageIndex < 0) pageIndex = 0;
    if (pageIndex > dots.length - 1) pageIndex = dots.length - 1;

    dots.forEach(function(dot, idx) {
      dot.classList.toggle("is-active", idx === pageIndex);
    });
  }

  function setActiveBrand(section, brandKey) {
    var tabs = section.querySelectorAll("[data-tire-brand-tab]");
    var cards = section.querySelectorAll("[data-tire-card]");
    var track = section.querySelector("[data-tire-track]");

    tabs.forEach(function(tab) {
      var active = tab.dataset.brand === brandKey;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
    });

    cards.forEach(function(card) {
      card.hidden = card.dataset.brand !== brandKey;
    });

    if (track) track.scrollLeft = 0;
    syncArrows(section);
    renderDots(section);
    syncDots(section);
  }

  function attachCarousel(section) {
    var track = section.querySelector("[data-tire-track]");
    var prev = section.querySelector("[data-tire-prev]");
    var next = section.querySelector("[data-tire-next]");
    if (!track || !prev || !next) return;

    function scrollByStep(direction) {
      var step = Math.max(220, Math.round(track.clientWidth * 0.78));
      track.scrollBy({ left: direction * step, behavior: "smooth" });
    }

    prev.addEventListener("click", function() { scrollByStep(-1); });
    next.addEventListener("click", function() { scrollByStep(1); });
    track.addEventListener("scroll", function() {
      syncArrows(section);
      syncDots(section);
    }, { passive: true });
    window.addEventListener("resize", function() {
      syncArrows(section);
      renderDots(section);
      syncDots(section);
    });
    track.querySelectorAll("img").forEach(function(image) {
      image.addEventListener("load", function() {
        syncArrows(section);
        renderDots(section);
        syncDots(section);
      });
    });
    renderDots(section);
    syncDots(section);
    syncArrows(section);
  }

  function attachBrandTabsScroller(section) {
    var tabs = section.querySelector(".tire-brand-explorer__brand-tabs");
    if (!tabs) return;
    var shared = window.PrinceExplorers;
    if (!shared || typeof shared.attachScrollableTabsWithFade !== "function") return;
    shared.attachScrollableTabsWithFade(tabs);

    var nudgeDistance = 62;
    var nudgedOnce = false;

    function canNudge() {
      if (window.matchMedia("(min-width: 750px)").matches) return false;
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      if (maxScroll <= 2) return false;
      return tabs.scrollLeft < (maxScroll - 8);
    }

    function runSwipeNudgeOnce() {
      if (nudgedOnce || !canNudge()) return;
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      var start = tabs.scrollLeft;
      var forward = Math.min(start + nudgeDistance, maxScroll);
      if (forward <= start + 1) return;
      tabs.scrollTo({ left: forward, behavior: "smooth" });
      nudgedOnce = true;
    }

    window.setTimeout(runSwipeNudgeOnce, 1000);
  }

  function attachInteractions(section) {
    section.addEventListener("click", function(event) {
      var tab = event.target.closest("[data-tire-brand-tab]");
      if (tab) {
        setActiveBrand(section, tab.dataset.brand || "");
        return;
      }

      var openTrigger = event.target.closest("[data-tire-open-modal]");
      if (openTrigger) {
        var card = openTrigger.closest("[data-tire-card]");
        if (card) {
          fillModalFromCard(section, card);
          setModalState(section, true);
        }
        return;
      }

      var closeTrigger = event.target.closest("[data-tire-modal-close], [data-tire-modal-backdrop]");
      if (closeTrigger) {
        setModalState(section, false);
      }
    });
  }

  function setModalState(section, isOpen) {
    var modal = section.querySelector("[data-tire-modal]");
    if (!modal) return;
    modal.hidden = !isOpen;
    modal.setAttribute("aria-hidden", isOpen ? "false" : "true");
    document.documentElement.classList.toggle("tire-brand-explorer-modal-open", isOpen);
  }

  function setText(el, value, fallback) {
    if (!el) return;
    var text = (value || "").trim();
    el.textContent = text || (fallback || "");
  }

  function parseScore(value, fallback) {
    var n = Number(value);
    if (!isFinite(n)) {
      if (typeof fallback === "number" && isFinite(fallback)) return Math.round(fallback);
      return null;
    }
    if (n <= 0) return null;
    if (n > 100) return 100;
    return Math.round(n);
  }

  function getNoiseLevelMeta(level) {
    var normalized = String(level || "").toLowerCase();
    if (!normalized) return null;
    if (normalized === "low") return { dots: 1, label: "Low" };
    if (normalized === "high") return { dots: 5, label: "High" };
    return { dots: 3, label: "Medium" };
  }

  function resolveNoiseLevel(rawNoise, facts, benchmark) {
    if (facts && facts.noise) return String(facts.noise).toLowerCase();
    if (benchmark && benchmark.noise) return String(benchmark.noise).toLowerCase();
    var normalized = String(rawNoise || "").toLowerCase();
    if (normalized === "low" || normalized === "high") return normalized;
    return "";
  }

  function resolveRunFlat(rawRunFlat, facts) {
    if (facts && typeof facts.runFlat === "boolean") return facts.runFlat;
    var normalized = String(rawRunFlat || "").toLowerCase();
    if (normalized === "yes") return true;
    return null;
  }

  function resolveScore(rawScore, facts, benchmark, key) {
    var score = parseScore(rawScore);
    if (score !== null) return score;
    if (facts && typeof facts[key] === "number") {
      var factScore = parseScore(facts[key]);
      if (factScore !== null) return factScore;
    }
    if (!benchmark || typeof benchmark[key] !== "number") return null;
    return parseScore(benchmark[key]);
  }

  function fillModalFromCard(section, card) {
    applyModelFactsToCard(card);
    var brand = card.dataset.modelBrand || "";
    var title = card.dataset.modelName || "Tire model";
    var type = card.dataset.modelType || "";
    var facts = getModelFacts(title);
    var benchmark = getTypeBenchmark(type);
    var part = card.dataset.modelPart || "";
    var warranty = card.dataset.modelWarranty || "";
    var tier = card.dataset.modelTier || "";
    var bestFor = card.dataset.modelBestFor || "";
    var scoreIce = resolveScore(card.dataset.modelScoreIce, facts, benchmark, "scoreIce");
    var scoreSnow = resolveScore(card.dataset.modelScoreSnow, facts, benchmark, "scoreSnow");
    var scoreWet = resolveScore(card.dataset.modelScoreWet, facts, benchmark, "scoreWet");
    var scoreDry = resolveScore(card.dataset.modelScoreDry, facts, benchmark, "scoreDry");
    var scoreTread = resolveScore(card.dataset.modelScoreTread, facts, benchmark, "scoreTread");
    var noiseMeta = getNoiseLevelMeta(resolveNoiseLevel(card.dataset.modelNoise, facts, benchmark));
    var runFlatState = resolveRunFlat(card.dataset.modelRunFlat, facts);
    var years = card.dataset.modelYears || "";
    var fitment = card.dataset.modelFitment || "";
    var image = card.dataset.modelImage || "";
    setText(section.querySelector("[data-tire-modal-brand]"), brand, "Tire brand");
    setText(section.querySelector("[data-tire-modal-title]"), title, "Tire model");
    setText(section.querySelector("[data-tire-modal-part]"), part, "");
    setText(section.querySelector("[data-tire-modal-years]"), years, "");
    setText(section.querySelector("[data-tire-modal-fitment]"), fitment, "");

    var quickInfo = section.querySelector("[data-tire-modal-quick]");
    if (quickInfo) {
      var bits = [];
      if (type) bits.push(type);
      if (years) bits.push("Best years: " + years);
      if (fitment) bits.push("Popular models: " + fitment);
      if (!bits.length) bits.push("Quick info is being updated for this model.");
      quickInfo.textContent = bits.join(" • ");
    }

    var partRow = section.querySelector("[data-tire-modal-part-row]");
    if (partRow) partRow.hidden = !part;
    var warrantyRow = section.querySelector("[data-tire-modal-warranty-row]");
    if (warrantyRow) warrantyRow.hidden = !warranty;
    var tierRow = section.querySelector("[data-tire-modal-tier-row]");
    if (tierRow) tierRow.hidden = !tier;
    var bestForRow = section.querySelector("[data-tire-modal-best-for-row]");
    if (bestForRow) bestForRow.hidden = !bestFor;
    var yearsRow = section.querySelector("[data-tire-modal-years-row]");
    if (yearsRow) yearsRow.hidden = !years;
    var fitmentRow = section.querySelector("[data-tire-modal-fitment-row]");
    if (fitmentRow) fitmentRow.hidden = !fitment;

    setText(section.querySelector("[data-tire-modal-warranty]"), warranty, "");
    setText(section.querySelector("[data-tire-modal-tier]"), tier, "");
    setText(section.querySelector("[data-tire-modal-best-for]"), bestFor, "");

    var typeBadge = section.querySelector("[data-tire-modal-type-badge]");
    if (typeBadge) {
      typeBadge.hidden = !type;
      typeBadge.textContent = type || "";
    }
    var tierBadge = section.querySelector("[data-tire-modal-tier-badge]");
    if (tierBadge) {
      tierBadge.hidden = !tier;
      tierBadge.textContent = tier || "";
    }
    var bestForSub = section.querySelector("[data-tire-modal-best-for-sub]");
    if (bestForSub) {
      bestForSub.hidden = !bestFor;
      bestForSub.textContent = bestFor ? ("Best for: " + bestFor) : "";
    }

    var iconEl = section.querySelector("[data-tire-modal-icon]");
    if (iconEl) {
      var icon = "🛞";
      var lowerType = String(type || "").toLowerCase();
      if (lowerType.indexOf("winter") > -1) icon = "❄️";
      else if (lowerType.indexOf("all-season") > -1 || lowerType.indexOf("all season") > -1) icon = "🛞";
      else if (lowerType.indexOf("all-weather") > -1 || lowerType.indexOf("all weather") > -1) icon = "🌧️";
      else if (lowerType.indexOf("summer") > -1) icon = "☀️";
      iconEl.textContent = icon;
    }

    setText(section.querySelector("[data-tire-modal-score-ice]"), scoreIce === null ? "" : String(scoreIce), "No data");
    setText(section.querySelector("[data-tire-modal-score-snow]"), scoreSnow === null ? "" : String(scoreSnow), "No data");
    setText(section.querySelector("[data-tire-modal-score-wet]"), scoreWet === null ? "" : String(scoreWet), "No data");
    setText(section.querySelector("[data-tire-modal-score-dry]"), scoreDry === null ? "" : String(scoreDry), "No data");
    setText(section.querySelector("[data-tire-modal-score-tread]"), scoreTread === null ? "" : String(scoreTread), "No data");
    setText(section.querySelector("[data-tire-modal-noise-label]"), noiseMeta ? noiseMeta.label : "", "No data");

    var iceBar = section.querySelector("[data-tire-modal-bar-ice]");
    var snowBar = section.querySelector("[data-tire-modal-bar-snow]");
    var wetBar = section.querySelector("[data-tire-modal-bar-wet]");
    var dryBar = section.querySelector("[data-tire-modal-bar-dry]");
    var treadBar = section.querySelector("[data-tire-modal-bar-tread]");
    if (iceBar) iceBar.style.width = scoreIce === null ? "0%" : (scoreIce + "%");
    if (snowBar) snowBar.style.width = scoreSnow === null ? "0%" : (scoreSnow + "%");
    if (wetBar) wetBar.style.width = scoreWet === null ? "0%" : (scoreWet + "%");
    if (dryBar) dryBar.style.width = scoreDry === null ? "0%" : (scoreDry + "%");
    if (treadBar) treadBar.style.width = scoreTread === null ? "0%" : (scoreTread + "%");

    var noiseDots = section.querySelectorAll("[data-tire-modal-noise-dot]");
    noiseDots.forEach(function(dot, idx) {
      dot.classList.toggle("is-on", !!noiseMeta && idx < noiseMeta.dots);
    });

    var rowIce = section.querySelector("[data-tire-modal-score-row-ice]");
    var rowSnow = section.querySelector("[data-tire-modal-score-row-snow]");
    var rowWet = section.querySelector("[data-tire-modal-score-row-wet]");
    var rowDry = section.querySelector("[data-tire-modal-score-row-dry]");
    var rowTread = section.querySelector("[data-tire-modal-score-row-tread]");
    var noiseRow = section.querySelector("[data-tire-modal-noise-row]");
    var scoresWrap = section.querySelector("[data-tire-modal-scores]");

    if (rowIce) rowIce.hidden = false;
    if (rowSnow) rowSnow.hidden = false;
    if (rowWet) rowWet.hidden = false;
    if (rowDry) rowDry.hidden = false;
    if (rowTread) rowTread.hidden = false;
    if (noiseRow) noiseRow.hidden = false;

    if (scoresWrap) scoresWrap.hidden = false;

    var runflatRow = section.querySelector("[data-tire-modal-runflat-row]");
    if (runflatRow) runflatRow.hidden = runFlatState === null;
    var runflatText = section.querySelector("[data-tire-modal-runflat]");
    if (runflatText) runflatText.textContent = runFlatState === null ? "" : (runFlatState ? "Yes" : "No");

    var imageRow = section.querySelector("[data-tire-modal-image-row]");
    var imageEl = section.querySelector("[data-tire-modal-image]");
    if (imageRow && imageEl) {
      if (image) {
        imageEl.src = image;
        imageEl.alt = title;
        imageRow.hidden = false;
      } else {
        imageRow.hidden = true;
      }
    }

    var shopButton = section.querySelector("[data-tire-modal-shop]");
    if (shopButton) {
      shopButton.dataset.modelBrand = brand;
    }
  }

  function initSection(section) {
    if (!section || section.dataset.tireBrandExplorerInit === "true") return;
    section.dataset.tireBrandExplorerInit = "true";

    attachInteractions(section);
    attachBrandTabsScroller(section);
    attachCarousel(section);
    hydrateCardsWithFacts(section);
    attachDatasetLazyLoad(section);
    syncArrows(section);
    renderDots(section);
    syncDots(section);

    var firstTab = section.querySelector("[data-tire-brand-tab]");
    if (firstTab) {
      setActiveBrand(section, firstTab.dataset.brand || "");
    }

    document.addEventListener("keydown", function(event) {
      if (event.key !== "Escape") return;
      var modal = section.querySelector("[data-tire-modal]");
      if (!modal || modal.hidden) return;
      setModalState(section, false);
    });
  }

  function initAll() {
    document.querySelectorAll("[data-tire-brand-explorer]").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function(event) {
    var section = event.target && event.target.querySelector("[data-tire-brand-explorer]");
    if (section) initSection(section);
  });
})();
